import { WorkflowNodeId, WorkflowVersionId } from '@ply-io/ply-front-shared-utilities';

import { initWidgetFields } from '@/store/modules/widgetEditor/actions';
import { useStore } from '@/utils/store';

export const useWidgetEditorActions = () => {
	const { dispatch } = useStore();
	return {
		initWidgetFields: (p: { id: string; workflowVersionId: WorkflowVersionId; nodeId: WorkflowNodeId }) =>
			dispatch<{ id: string; workflowVersionId: WorkflowVersionId; nodeId: WorkflowNodeId }, void>(initWidgetFields, p),
	};
};
